export default function AppSection() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-3">
                APP下载
              </h2>
              <p className="text-sm md:text-base text-background-200 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                歪歪漫画网移动客户端即将上线！专为手机优化的阅读体验，离线缓存、夜间模式、更新推送等贴心功能，让你随时随地畅享漫画世界。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#hero"
                  onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }}
                  className="flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-600 font-semibold rounded-full hover:bg-background-100 transition-colors text-sm cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-android-line text-lg"></i>
                  Android 版
                </a>
                <a
                  href="#hero"
                  onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }}
                  className="flex items-center gap-2 px-6 py-3 bg-background-950/20 text-background-50 font-semibold rounded-full hover:bg-background-950/30 transition-colors border border-background-50/30 text-sm cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-apple-line text-lg"></i>
                  iOS 版
                </a>
              </div>
            </div>
            <div className="flex-1 w-full max-w-sm lg:max-w-none p-6 md:p-8">
              <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden bg-background-950/10">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20clean%20modern%20smartphone%20mockup%20displaying%20a%20colorful%20manga%20reading%20app%20interface%20on%20its%20screen%2C%20floating%20on%20a%20warm%20gradient%20background%20with%20soft%20coral%20and%20cream%20tones%2C%20minimalist%20product%20photography%20style%2C%20no%20text%20visible%20on%20the%20phone%20screen%2C%20editorial%20quality%2C%20clean%20composition&width=600&height=450&seq=app-mockup-2026&orientation=landscape"
                  alt="歪歪漫画网 APP 预览"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}